<template>
  <div class="Consult">
    <RouteHeadAndCrumbs
      :backgroundImg="backgroundImg"
      :breadcrumbsInfo="breadcrumbsInfo"
    />
    <div class="consult-container">
      <div class="one-consult-info-container">
        <div class="title-text">
          <div class="title-line" />
          <span>关于您的产品需求</span>
        </div>
        <div class="one-consult-form-container">
          <div class="one-form-item">
            <div class="one-item-label">
              <span>您感兴趣的产品</span>
            </div>
            <div class="one-item-content">
              <el-select
                filterable
                v-model="form.productId"
                placeholder="请选择产品"
              >
                <template v-for="item in productList">
                  <el-option :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </template>
              </el-select>
            </div>
          </div>
          <div class="one-form-item">
            <div class="one-item-label">
              <span>您的项目规模</span>
            </div>
            <div class="one-item-content">
              <el-select
                v-model="form.productScale"
                placeholder="请选择项目规模"
              >
                <el-option label="暂不明确" value="unknow"> </el-option>
                <el-option label="10W以下" value="0-10"> </el-option>
                <el-option label="10W-50W" value="10-50"> </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="one-consult-form-container is-full-row">
          <div class="one-form-item">
            <div class="one-item-label">
              <span>项目描述</span>
            </div>
            <div class="one-item-content">
              <el-input
                type="textarea"
                :rows="10"
                placeholder="项目需求描述"
                v-model="form.productDesc"
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="one-consult-info-container">
        <div class="title-text">
          <div class="title-line" />
          <span>如何与您取得联系</span>
        </div>
        <div class="one-consult-form-container">
          <div class="one-form-item">
            <div class="one-item-label">
              <span>公司名称</span>
            </div>
            <div class="one-item-content">
              <el-input
                v-model="form.companyName"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <div class="one-form-item">
            <div class="one-item-label">
              <span>所在行业</span>
            </div>
            <div class="one-item-content">
              <!-- <el-select placeholder="请选择产品">
                                <el-option label="新能源" value="new-power">
                                </el-option>
                            </el-select> -->
              <el-input v-model="form.industry" placeholder="请输入"></el-input>
            </div>
          </div>
        </div>
        <div class="one-consult-form-container">
          <div class="one-form-item">
            <div class="one-item-label">
              <span>职务</span>
            </div>
            <div class="one-item-content">
              <el-input v-model="form.job" placeholder="请输入"></el-input>
            </div>
          </div>
          <div class="one-form-item">
            <div class="one-item-label">
              <span>姓名</span>
            </div>
            <div class="one-item-content">
              <el-input v-model="form.name" placeholder="请输入"></el-input>
            </div>
          </div>
        </div>
        <div class="one-consult-form-container">
          <div class="one-form-item">
            <div class="one-item-label">
              <span>邮箱</span>
            </div>
            <div class="one-item-content">
              <el-input v-model="form.mail" placeholder="请输入"></el-input>
            </div>
          </div>
          <div class="one-form-item">
            <div class="one-item-label">
              <span>电话</span>
            </div>
            <div class="one-item-content">
              <el-input v-model="form.phone" placeholder="请输入"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="submit-form-info-container">
        <div class="submit-btn-container">
          <el-button
            class="submit-btn"
            type="primary"
            @click="submitConsultData"
            >提 交</el-button
          >
        </div>
        <p class="allow-info-text">
          <span>点击“提交”,表明我理解并同意</span>
          <el-link class="link-text" :underline="false" type="primary"
            >伦伟隐私条款</el-link
          >
        </p>
        <p class="desc-text">
          提交反馈，点击提交按钮后显示，您的咨询已提交成功，我们会在15分钟内电话联系您，该提示与置于页面上方，3s后自动消失
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import headImg from "../assets/images/61.png";

import { ROUTEINFO } from "../utils/constant";

import { GETPRODUCTLIST, SUBMITCONSULTINFO } from "../utils/uriList";

export default {
  mounted() {
    this.getProductList();
  },
  data() {
    return {
      backgroundImg: headImg,
      breadcrumbsInfo: [
        {
          routeName: ROUTEINFO.home.name,
          routeLabel: "首页",
          routeTo: {
            path: ROUTEINFO.home.path,
          },
        },
        {
          routeName: ROUTEINFO.consult.name,
          routeLabel: "咨询购买",
        },
      ],
      form: {
        productId: "",
        productScale: "",
        productDesc: "",
        companyName: "",
        industry: "",
        job: "",
        name: "",
        mail: "",
        phone: "",
      },
      productList: [],
    };
  },
  methods: {
    async getProductList() {
      const response = await this.$http.get(GETPRODUCTLIST);
      if (response.data.code === 0) {
        this.productList = response.data.data;
      }
    },
    async submitConsultData() {
      if (!this.form.productId) {
        this.$message.error("请选择您感兴趣的产品");
      } else if (!this.form.productScale) {
        this.$message.error("请选择您的项目规模");
      } else if (!this.form.productDesc) {
        this.$message.error("请填写您的项目需求描述");
      } else if (!this.form.companyName) {
        this.$message.error("请填写您的公司名称");
      } else if (!this.form.industry) {
        this.$message.error("请填写您的所在行业");
      } else if (!this.form.job) {
        this.$message.error("请填写您的职务");
      } else if (!this.form.name) {
        this.$message.error("请填写您的姓名");
      } else if (!this.form.mail) {
        this.$message.error("请填写您的邮箱");
      } else if (!this.form.phone) {
        this.$message.error("请填写您的电话");
      } else {
        const response = await this.$http.post(SUBMITCONSULTINFO, this.form);
        if (response.data.code === 0) {
          this.$message({
            type: "success",
            message: "您的咨询已提交成功",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/views/Consult.scss";
</style>
